// @ts-nocheck
import Vue from "vue";
import Auth from "@/services/Auth";
import storage from "@/storage/storage";
import { Api } from "@/services/Api";
import config from "@/services/Api-config";
import PermissionHelper from "@/permissions/PermissionHelper";

const showToast = ({ state, commit }, message: string) => {
  if (state.toast.show) commit("hideToast");

  setTimeout(() => {
    commit("showToast", {
      color: "black",
      message,
      timeout: 3000
    });
  });
};

const showError = ({ state, commit }, { message = "Failed!", error }) => {
  if (state.toast.show) commit("hideToast");

  setTimeout(() => {
    commit("showToast", {
      color: "error",
      message: message + " " + error.message,
      timeout: 10000
    });
  });
};

const showSuccess = ({ state, commit }, message: string) => {
  if (state.toast.show) commit("hideToast");
  setTimeout(() => {
    commit("showToast", {
      color: "success",
      message,
      timeout: 3000
    });
  });
};

async function getMyHotels({ state }) {
  const myHotel = await storage.getItem("my-hotels");
  if (typeof myHotel == "undefined" || myHotel == null) {
    Auth.GetTokenPayload().then(token => {
      Api.get(
        `/my/hotels/${token.uid}/v1`,
        null,
        null,
        null,
        null,
        null,
        config.SENTEC_ACCOUNTS_PROFILE
      ).then(res => {
        state.hotels = res.data.Data;
        storage.setItem("my-hotels", res.data);
      });
    });
  } else {
    state.hotels = myHotel.Data;
  }
}

async function getMyProfile({ state }) {
  const myProfile = await storage.getItem("user");
  if (typeof myProfile == "undefined" || myProfile == null) {
    Auth.GetTokenPayload().then(token => {
      Api.get(
        `/my/profile/${token.uid}/v1`,
        null,
        null,
        null,
        null,
        null,
        config.SENTEC_ACCOUNTS_PROFILE
      ).then(res => {
        state.user = res.data.Data;
        storage.setItem("user", res.data);
        PermissionHelper.storeAndEncryptUserInformation(res.data);

        const googleCredential = typeof res.data.Data.google_credential != "undefined" && res.data.Data.google_credential ?
          res.data.Data.google_credential : "";
        if (googleCredential.toString().length > 1) {
          localStorage.setItem("google-credential", googleCredential);
        }
        if ((<IMyProfile>res.data.Data).force_change_password) {
          PermissionHelper.removeEncryptedUserInformation();
          window.location.href = `${process.env.VUE_APP_WEB_ACCOUNT_URL}/my-account/change-password?force=1&next=${window.location.href}`;
        }
      });
    });
  } else {
    state.user = myProfile.Data;
  }
}

async function setSyncing({ commit }, isSyncing) {
  commit("setSyncing", isSyncing);
}

export default {
  showToast,
  showError,
  showSuccess,
  getMyHotels,
  getMyProfile,
  setSyncing
};
